import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ManageTourList'],
});
const transformDownloadFile = (response) => {
  console.log('here?');
  try {
    return JSON.parse(response);
  } catch (e) {
    return response;
  }
};
export const manageTourListApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findSearchManageTourListPagination: builder.query({
      query: (payload) => {
        let url = `manage-tour-list/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
    }),
    findSearchDatatable: builder.query({
      query: () => `manage-tour-list/?limit=500`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourList'],
    }),

    findDataInit: builder.mutation({
      query: () => `manage-tour-list-init/`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourList'],
    }),
    findDataManageTourEditInit: builder.mutation({
      query: (id) => `manage-tour-list-edit/init/?tour_id=${id}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourList'],
    }),
    findDataManageTourEditInitJobcode: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list-edit/jobcode/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    findStatusTotalRecord: builder.mutation({
      query: (payload) => {
        let url = `manage-tour-list/summary/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourList'],
    }),
    findCompanies: builder.query({
      query: () => `status_summary/selection_data/vl/`,
      providesTags: ['ManageTourList'],
    }),
    updateManageTour: builder.mutation({
      query: (payment) => ({
        url: `manage-tour-list/${payment.id}/`,
        method: 'PATCH',
        body: payment,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    deleteManageTour: builder.mutation({
      query: (id) => ({
        url: `manage-tour-list/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    releaseJobcode: builder.mutation({
      query: (id) => ({
        url: `manage-tour-list/${id}/release-jobcode/`,
        method: 'POST',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    findSimilarTours: builder.query({
      query: (id) => ({
        url: `manage-tour-list/${id}/similar-tours/`,
        method: 'GET',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    recvJobCheck: builder.mutation({
      query: (body) => ({
        url: `manage-tour-list/recv-job-time-check/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    findAvailableJobcodes: builder.mutation({
      query: (body) => ({
        url: `manage-tour-list/available-jobcodes/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    applyJobcode: builder.mutation({
      query: (body) => ({
        url: `manage-tour-list/apply-jobcode/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    purgeTour: builder.mutation({
      query: (id) => ({
        url: `manage-tour-list/${id}/purge/`,
        method: 'POST',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    submitManageTour: builder.mutation({
      query: (payment) => ({
        url: `manage-tour-list/submit/`,
        method: 'POST',
        body: payment,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    matchManageTour: builder.mutation({
      query: () => ({
        url: `manage-tour-list-match-by-system/`,
        method: 'POST',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    findStatusMatchManageTour: builder.mutation({
      query: () => ({
        url: `manage-tour-list-match-by-system/`,
        method: 'POST',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    notifyManageTour: builder.mutation({
      query: () => ({
        url: `manage-tour-list-notify/`,
        method: 'POST',
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    notifyBzpManageTour: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list-notify/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    updateManageTourEdit: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list-edit/save/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    updateManageTourHourCal: builder.mutation({
      query: (payload) => ({
        url: `manage-tour-list-edit/hour-calc/`,
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['ManageTourList'],
    }),
    findDataNotifyBzpCheck: builder.mutation({
      query: (payload) => `manage-tour-list-notify/?bzp=${payload}`,
      keepUnusedDataFor: 0,
      providesTags: ['ManageTourList'],
    }),

    findDownloadCSVManageTourList: builder.mutation({
      query: (payload) => {
        let url = `manage-tour-list/download/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });

        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return {
          url: `${url}?${searchParams.toString()}`,
          responseHandler: (response) => response.text(),
        };
      },
    }),

    findDownloadJobCodeCSVManageTourList: builder.mutation({
      query: (payload) => {
        let url = `jobcode-calendar/download/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });

        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return {
          url: `${url}?${searchParams.toString()}`,
          responseHandler: (response) => response.text(),
        };
      },
    }),

    findManageTourListStatus: builder.query({
      query: () => `manage-tour-list-status/`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindSearchDatatableQuery,
  useFindManageTourListStatusQuery,
  useFindDataInitMutation,
  useFindStatusTotalRecordMutation,
  useFindCompaniesQuery,
  useFindSimilarToursQuery,
  useFindAvailableJobcodesMutation,
  useRecvJobCheckMutation,
  useApplyJobcodeMutation,
  useDeleteManageTourMutation,
  useReleaseJobcodeMutation,
  usePurgeTourMutation,
  useSubmitManageTourMutation,
  useMatchManageTourMutation,
  useNotifyManageTourMutation,
  useNotifyBzpManageTourMutation,
  useUpdateManageTourEditMutation,
  useUpdateManageTourHourCalMutation,
  useFindDataNotifyBzpCheckMutation,
  useFindDownloadCSVManageTourListMutation,
  useFindDownloadJobCodeCSVManageTourListMutation,
} = manageTourListApi;
